import React from "react";
import "../Style/AboutUs.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div className="location-container">
      <section className="location-section">
        <div className="location-text">
          <h1 className="location-title">{t("about.findUs")}</h1>
          <p className="location-description">{t("about.description")}</p>
          <div className="location-info">
            <p><strong>{t("about.addressLabel")}</strong> {t("about.address")}</p>
            <p><strong>{t("about.phoneLabel")}</strong>+972 59-899-5512</p>
            <p><strong>{t("about.hoursLabel")}</strong> {t("about.hours")}</p>
          </div>
          <Link to="/" className="location-button">{t("about.backToHome")}</Link>
        </div>

        <div className="location-map">
        <iframe
  title={t("about.mapTitle")}
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3388.4130572081974!2d35.11118787464373!3d31.598764844063327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1502db3a5c351e71%3A0x5d6e06617869f5f4!2z2KfZhNmF2LnYqSDYp9mE2LnZgdiq2K_YsQ!5e0!3m2!1sen!2s!4v1717152698480!5m2!1sen!2s"
  width="100%"
  height="300"
  allowFullScreen
  loading="lazy"
  className="map-iframe"
/>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
